import React, {useEffect, useState} from 'react';
import {mrbgStore} from './mrbgRedux/index.js';

function MrbgCheckBox({formID,name,other,formStyle}){

  const
    [redFld,setRedFld] = useState( mrbgStore.getState().formsSettings[formID]?.redFld || [] ),
    id = 'NC_'+formID+name.substring(0,1).toUpperCase()+name.substring(1);

  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setRedFld( mrbgStore.getState().formsSettings[formID]?.redFld || [] );
    })
    return () =>unsubscribe();
  },[]);

  return(
    <div className={`${formStyle.mrbgCheckBox} ${redFld.includes(name)? formStyle.emptyField: ''}`} tabIndex={0} onKeyUp={e=>{if (e.key === 'Enter' || e.keyCode === 13) {
      const input = e.currentTarget.querySelector('input');
      if( input ){
        input.checked = !input.checked;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }}}>
      <input type="checkbox" name={name} id={id} {...other}/>
      <label htmlFor={id}></label>
    </div>
  )
}

export default MrbgCheckBox;